import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/233505066691?text=Hi%20VelTech%2C%20I%20found%20your%20site%20and%20I%20need%20a%20custom%20proposal%20for%20my%20school.";

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white font-black px-5 py-3.5 shadow-lg shadow-[#25D366]/30 transition-all duration-200 hover:scale-105 group"
      style={{ fontFamily: "'Satoshi', sans-serif" }}
    >
      <MessageCircle size={22} strokeWidth={2.5} className="flex-shrink-0" />
      <span className="text-sm uppercase tracking-wider hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
